import { provideZoneChangeDetection, APP_INITIALIZER, importProvidersFrom } from "@angular/core";
import '@angular/compiler';


import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import { environment } from './environments/environment';
import { SalesViewService } from "./app/components/pages/sales/sales-view.service";
import { HTTP_INTERCEPTORS, provideHttpClient, withXhr, withInterceptorsFromDi } from "@angular/common/http";
import { InterceptorService } from "./app/components/shared/interceptor.service";
import { PermissionsService } from "./app/components/shared/permissions/permissions.service";
import { localStorageService } from "./app/components/shared/localstorage.service";
import { firstValueFrom } from "rxjs";
import { SharedService } from "./app/components/shared/shared.service";
import { MainService } from "./app/components/shared/main.service";
import { ApiService } from "./app/components/shared/api.service";
import { ToasterService } from "./app/components/shared/toaster/toaster.service";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter, withPreloading, PreloadAllModules } from "@angular/router";
import { routes } from "./app/routes";
import { CommonModule } from "@angular/common";
import { PaginationConfig, PaginationModule } from "ngx-bootstrap/pagination";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { NgxSelectModule, INgxSelectOptions } from "ngx-select-ex";
import { AssignmentsService } from "./app/components/pages/assignments/assignments.service";

const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: "id",
  optionTextField: "name",
};
import { DatePipe, DecimalPipe } from "@angular/common";
import { provideNgxMask } from "ngx-mask";
import { Loader } from "@googlemaps/js-api-loader";
import { NgxEditorModule } from "ngx-editor";
import { ClaimService } from "./app/components/pages/claims/claims.service";
import { AppComponent } from "./app/app.component";
import { provideHighcharts } from "highcharts-angular";

function initPermissionsFactory(perms: PermissionsService, local: localStorageService): () => Promise<unknown> {
  return () => {
    if (!local.customGetItem('token')) {
      return Promise.resolve();
    }
    return firstValueFrom(perms.refresh()).catch(() => null);
  };
}



if (environment.production) {
  // Disable console methods in production
  console.log = () => {};
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideHighcharts({ instance: () => import("highcharts/esm/highcharts").then(m => m.default) }),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        importProvidersFrom(BrowserModule, BrowserAnimationsModule, CommonModule, PaginationModule, AccordionModule, NgxSelectModule.forRoot(CustomSelectOptions), NgxEditorModule.forRoot({ locals: { bold: "Bold", italic: "Italic", code: "Code", underline: "Underline", strike: "Strike", blockquote: "Blockquote", bullet_list: "Bullet List", ordered_list: "Ordered List", heading: "Heading", h1: "Header 1", h2: "Header 2", h3: "Header 3", h4: "Header 4", h5: "Header 5", h6: "Header 6", align_left: "Left Align", align_center: "Center Align", align_right: "Right Align", align_justify: "Justify", text_color: "Text Color", background_color: "Background Color", url: "URL", text: "Text", openInNewTab: "Open in new tab", insert: "Insert", altText: "Alt Text", title: "Title", remove: "Remove" } })),
        PaginationConfig,
        localStorageService,
        DatePipe,
        DecimalPipe,
        ClaimService,
        provideNgxMask(),
        {
            provide: Loader,
            useValue: new Loader({
                apiKey: window.location.href.includes(".financemutual.com")
                    ? "AIzaSyAa0GBtCtHP69nQ3EhYc69G2xyXXXAQCYE"
                    : "AIzaSyAB3iHn_Dc0nEjS7q53tfCBWVm1_Dj1fdI",
                libraries: ["places"],
            }),
        },
        AssignmentsService,
        SalesViewService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initPermissionsFactory,
            deps: [PermissionsService, localStorageService],
            multi: true
        },
        SharedService,
        MainService,
        ApiService, ToasterService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
.then(() => {
  const appRoot = document.querySelector('[ng-version]');
  appRoot?.removeAttribute('ng-version');
}).catch(err => console.error(err));
